import { useMemo } from "react";
import { ActivityIndicator } from "react-native";

import { useTheme } from "../../utils";
import { getButtonIconColorStyles } from "./styles";

import type { IconProps } from "@smartrent/icons";
import type { ComponentType } from "react";
import type { ButtonColors, ButtonSize, ButtonVariation } from "./types";

export interface ButtonAdornmentProps {
  pressed: boolean;
  hovered: boolean;
  isLoading: boolean;
  variation: ButtonVariation;
  color: ButtonColors;
  size?: ButtonSize;
  disabled: boolean;
  Icon?: ComponentType<IconProps>;
  type: "left" | "right";
}

export function ButtonAdornment({
  pressed,
  hovered,
  isLoading,
  variation,
  color,
  size,
  disabled,
  Icon,
  type,
}: ButtonAdornmentProps) {
  const { spacing, isLightMode, colors } = useTheme();

  const iconColorStyles = useMemo<{
    normal: { color: string };
    // used for pressed and hover states
    active?: { color: string };
  }>(() => {
    return getButtonIconColorStyles({
      variation,
      color,
      disabled,
      colors,
      isLightMode,
      isLoading,
    });
  }, [variation, color, disabled, colors, isLightMode, isLoading]);

  if (!Icon) return null;

  return isLoading ? (
    <ActivityIndicator
      style={
        type == "left"
          ? {
              marginRight: spacing.sm,
              marginLeft: -2,
            }
          : { marginLeft: spacing.sm, marginRight: -2 }
      }
      color={iconColorStyles.normal.color}
    />
  ) : (
    <Icon
      size={size === "x-small" ? 20 : 24}
      {...(pressed || hovered
        ? iconColorStyles?.active ?? iconColorStyles.normal
        : iconColorStyles.normal)} // Returns our color prop
      style={
        type == "left"
          ? {
              marginRight: spacing.sm,
              marginLeft: -2,
            }
          : { marginLeft: spacing.sm, marginRight: -2 }
      }
    />
  );
}
